// extracted by mini-css-extract-plugin
export default {"headerLogoWrapper":"Logo_headerLogoWrapper__u-f03","logo":"Logo_logo__2FriI"};